import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import USLLogo from './USLLogo';
import ThemeToggle from './ThemeToggle';
import UserProfile from './UserProfile';

const Header = ({ currentView, onNavigate, user, onLogout }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const navItems = [
    { id: 'home', label: 'Home' },
    { id: 'kit-designer', label: 'Customization' },
    { id: 'products', label: 'Products' },
    { id: 'about', label: 'About' },
    { id: 'contact', label: 'Contact' },
    { id: 'admin', label: 'Admin', className: 'admin-link' }
  ];

  if (!user) {
    navItems.push({ id: 'auth', label: 'Login', className: 'auth-link' });
  }

  const handleNav = (id) => {
    setMenuOpen(false);
    onNavigate && onNavigate(id);
  };

  return (
    <div className="header-wrap">
      <motion.header
        className="header"
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="header-content">
          <motion.div
            className="logo-container"
            whileHover={{ scale: 1.05 }}
            onClick={() => handleNav('home')}
            style={{ cursor: 'pointer' }}
          >
            <USLLogo size="medium" />
            <span className="brand-name">Universal Sports Lab</span>
          </motion.div>

          {/* Desktop nav */}
          <nav className="nav-desktop">
            <ul className="nav-links">
              {navItems.map((item) => (
                <li key={item.id}>
                  <motion.a
                    href={`#${item.id}`}
                    className={`${currentView === item.id ? 'active' : ''} ${item.className || ''}`}
                    onClick={(e) => { e.preventDefault(); handleNav(item.id); }}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    {item.label}
                  </motion.a>
                </li>
              ))}
            </ul>
            {user && onLogout && <UserProfile user={user} onLogout={onLogout} />}
            <ThemeToggle />
          </nav>

          {/* Mobile right — theme toggle + hamburger only */}
          <div className="header-right">
            <ThemeToggle />
            <button
              className="nav-hamburger"
              aria-label={menuOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen(o => !o)}
            >
              <span className={`hamburger-bar ${menuOpen ? 'open' : ''}`} />
              <span className={`hamburger-bar ${menuOpen ? 'open' : ''}`} />
              <span className={`hamburger-bar ${menuOpen ? 'open' : ''}`} />
            </button>
          </div>
        </div>

        {/* Mobile drawer */}
        <AnimatePresence>
          {menuOpen && (
            <motion.nav
              className="nav-mobile"
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: 'auto', opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.25 }}
            >
              <ul className="nav-mobile-links">
                {navItems.map((item) => (
                  <li key={item.id}>
                    <a
                      href={`#${item.id}`}
                      className={`${currentView === item.id ? 'active' : ''} ${item.className || ''}`}
                      onClick={(e) => { e.preventDefault(); handleNav(item.id); }}
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
                {user && onLogout && (
                  <li className="nav-mobile-user">
                    <UserProfile user={user} onLogout={() => { setMenuOpen(false); onLogout(); }} />
                  </li>
                )}
              </ul>
            </motion.nav>
          )}
        </AnimatePresence>
      </motion.header>
    </div>
  );
};

export default Header;
